/*
* Pipeline Theme – VANA custom.js
* Bereinigt 12.10.2026: Debug-Logs auf Scroll/Cart/Variant entfernt,
* Smile-Launcher-Beobachter auf Cart-Drawer-Ereignisse begrenzt.
* 19.10.2026: STKY-Workaround entfernt (App deinstalliert, eigener Sticky-Button vana-sticky-atc).
*/

/* === VANA CUSTOM: Upsell über Versand platzieren (21.11.2025) === */
(function () {
  function moveUpsell() {
    const upsell = document.querySelector(".upsell__holder");
    const shippingMeta = document.querySelector(".drawer__bottom__meta");
    if (!upsell || !shippingMeta) return;
    if (upsell.nextElementSibling === shippingMeta) return; // schon richtig platziert
    shippingMeta.parentNode.insertBefore(upsell, shippingMeta);
  }

  document.addEventListener("theme:cart:init", moveUpsell);
  document.addEventListener("theme:cart:change", moveUpsell);

  // Fallback, falls der Drawer später rendert (max. 4 s)
  let attempts = 0;
  const interval = setInterval(() => {
    moveUpsell();
    attempts++;
    if (attempts > 20) clearInterval(interval);
  }, 200);
})();

/* === VANA – Smile-Launcher ausblenden, solange der Cart Drawer offen ist === */
(() => {
  'use strict';

  const SMILE_CONTAINER_ID = 'smile-ui-lite-launcher-frame-container';
  const HIDE_CLASS = 'vana-hide-smile-launcher';

  function ensureStyleTag() {
    if (document.getElementById('vana-smile-hide-style')) return;
    const style = document.createElement('style');
    style.id = 'vana-smile-hide-style';
    style.textContent = `html.${HIDE_CLASS} #${SMILE_CONTAINER_ID}{display:none!important;visibility:hidden!important;pointer-events:none!important}`;
    document.head.appendChild(style);
  }

  function isCartDrawerOpen() {
    const drawer = document.querySelector('[data-cart-drawer], .cart-drawer, #CartDrawer, cart-drawer');
    if (drawer) {
      if (drawer.getAttribute('aria-hidden') === 'false') return true;
      if (drawer.classList.contains('is-open') || drawer.classList.contains('drawer--is-open')) return true;
    }
    // Pipeline setzt beim offenen Drawer einen Scroll-Lock auf <body>
    return document.body.getAttribute('data-scroll-lock-locked') === 'true';
  }

  function apply() {
    ensureStyleTag();
    document.documentElement.classList.toggle(HIDE_CLASS, isCartDrawerOpen());
  }

  let raf = null;
  function scheduleApply() {
    if (raf) return;
    raf = requestAnimationFrame(() => { apply(); raf = null; });
  }

  function init() {
    // Nur reagieren, wenn sich am <body> etwas ändert (Scroll-Lock, Drawer-Klassen) –
    // nicht mehr auf jede DOM-Änderung der ganzen Seite.
    const mo = new MutationObserver(scheduleApply);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style', 'data-scroll-lock-locked'] });
    document.addEventListener('theme:cart:change', scheduleApply);
    document.addEventListener('theme:cart:init', scheduleApply);
    document.addEventListener('click', scheduleApply, { passive: true, capture: true });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') scheduleApply(); });
    // Smile erscheint erst nach ~2 s
    setTimeout(scheduleApply, 800);
    setTimeout(scheduleApply, 2600);
    scheduleApply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
